import React from 'react'

interface CameraMarkerIconProps extends React.SVGProps<SVGSVGElement> {
    online: boolean
    isSelected?: boolean
    size?: number
}

const CameraMarkerIcon: React.FC<CameraMarkerIconProps> = ({ online, isSelected = false, size = 40, ...props }) => {
    const cameraColor = '#fff'
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle
                cx="20"
                cy="20"
                r="18"
                fill={online ? '#5ABEA6' : '#e07777'}
                stroke="#fff"
                strokeWidth="2"
            />
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 2V12H15V10V4V2H2ZM17 3.14286V1C17 0.447715 16.5523 0 16 0H1C0.447715 0 0 0.447716 0 1V13C0 13.5523 0.447715 14 1 14H16C16.5523 14 17 13.5523 17 13V10.8571L24 13V1L17 3.14286ZM17 6.31879V7.68121L21 9.24108V4.75892L17 6.31879Z"
                    fill={cameraColor}
                    stroke={cameraColor}
                    transform="translate(8,13)"
                />
            </g>
        </svg>
    )
}

export default CameraMarkerIcon 